import { render, staticRenderFns } from "./OnboardingEmail.vue?vue&type=template&id=1844fc4e&"
import script from "./OnboardingEmail.vue?vue&type=script&lang=js&"
export * from "./OnboardingEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports